import * as React from 'react';
import {
  Controller, useFieldArray, useFormContext,
} from 'react-hook-form';
import {
  ErrorMessage,
  PrimaryButton,
  PrimaryTextField,
  IconLoadingButton,
} from 'components';
import {
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';

import { PlusIcon, CloseSquareIcon } from 'assets/icons';
import { selectAchievements } from 'base/auth/selectors';
import { IUpdateProfileForm } from '../../interface';

const AchievementsForm = () => {
  const { control, formState: { errors } } = useFormContext<IUpdateProfileForm>();
  const { fields, append, remove } = useFieldArray({ name: 'achievements', control });

  const achievements = useSelector(selectAchievements);

  const addAchievement = () => { append({ title: '', description: '' }); };
  const removeAchievement = (i:number) => {
    remove(i);
  };

  React.useEffect(() => {
    remove();
    if (achievements) {
      achievements.forEach((achievement) => {
        append({ title: achievement.title, description: achievement.description });
      });
    }
  }, [achievements]);

  return (
    <>
      <div className="form-item">
        <Typography variant="h5" sx={{ mb: 2 }}>Achievements</Typography>
      </div>
      <div className="row">
        {fields.map((item, i) => (
          <div key={item.id} className="col-md-6">
            <div className="form-item">
              <div className="mb-2">
                <div className="mb-2">
                  <Typography variant="body1">
                    Achievement #
                    {' '}
                    {i + 1}
                  </Typography>
                </div>
                <div className="form-item">
                  <Controller
                    name={`achievements.${i as 0}.title`}
                    control={control}
                    render={({ field }) => <PrimaryTextField {...field} label="Title" />}
                  />
                </div>
                <div className="form-item">
                  <Controller
                    name={`achievements.${i as 0}.description`}
                    control={control}
                    render={({ field }) => <PrimaryTextField {...field} label="Description" />}
                  />
                </div>
                <IconLoadingButton
                  startIcon={<CloseSquareIcon />}
                  onClick={() => removeAchievement(i)}
                >
                  Remove
                </IconLoadingButton>
              </div>
              <div>
                <ErrorMessage>
                  {errors?.achievements ? errors?.achievements[i]?.title?.message : ' '}
                </ErrorMessage>
              </div>
              <div>
                <ErrorMessage>
                  {errors?.achievements ? errors?.achievements[i]?.description?.message : ' '}
                </ErrorMessage>
              </div>
            </div>
          </div>
        ))}
      </div>
      <PrimaryButton
        startIcon={<PlusIcon sx={{ color: '#fff' }} />}
        onClick={addAchievement}
      >
        Add a new achievement
      </PrimaryButton>
    </>
  );
};

export default AchievementsForm;
